export default {
      id: "camera-usage",
      viewBox: "0 0 30 18",
      url: __webpack_public_path__ + "img/icons.svg#camera",
      toString: function () {
        return this.url;
      }
    }